<button (click)="onHistoryButtonClick()" type="button" class="btn btn-primary">History</button>
